/**
 * Dispute type definitions and constants
 */

export type DisputeType = 
  | 'quality_issues'
  | 'missing_items'
  | 'damaged_goods'
  | 'late_delivery'
  | 'not_as_specified'
  | 'payment_disagreement'
  | 'vendor_non_performance'
  | 'client_non_compliance'
  | 'other';

export const DISPUTE_TYPES: { value: DisputeType; label: string; description: string }[] = [
  { value: 'quality_issues', label: 'Quality Issues', description: 'Delivered items do not meet specifications' },
  { value: 'missing_items', label: 'Missing/Incomplete Items', description: 'Not all ordered items were delivered' },
  { value: 'damaged_goods', label: 'Damaged Goods', description: 'Items were damaged during delivery' },
  { value: 'late_delivery', label: 'Late Delivery', description: 'Delivery past agreed timeline' },
  { value: 'not_as_specified', label: 'Not as Specified', description: 'Wrong products or specifications' },
  { value: 'payment_disagreement', label: 'Payment Disagreement', description: 'Dispute over charges or adjustments' },
  { value: 'vendor_non_performance', label: 'Vendor Non-Performance', description: 'Vendor failed to fulfill obligations' },
  { value: 'client_non_compliance', label: 'Client Non-Compliance', description: 'Client not meeting agreed terms' },
  { value: 'other', label: 'Other', description: 'Other issues not listed above' },
];
